import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

import _isEmpty from "lodash/isEmpty"

export const siteWideWarningModalCloseEventInfo = ({
  eventPageType = "",
  internalLinkName = "",
  internalLinkURL = "n/a",
  returnString = false,
  clickInternalLinks = "false",
}) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const content = page?.pageInfo?.contentType
  const pageInfoDetails = window?.adobeDataLayer?.getState("page")
  const { productInfo } = page

  const experienceName =
    content === "locations"
      ? "locations:kohler stores"
      : eventPageType || window?.eventPageType
  const eventName = `${experienceName}:share:${internalLinkName}`
  let internalLinkpositionName = `${experienceName}:social share pop up`
  if (
    pageInfoDetails?.pageInfo?.contentType &&
    pageInfoDetails?.pageInfo?.contentType === "pdp" &&
    !_isEmpty(productInfo)
  ) {
    if (productInfo.pdpType === "bundle") {
      internalLinkpositionName = "pdp:social share pop up:bundle"
    }
  }
  const eventInfo = {
    clickInternalLinks,
    eventAction: eventName,
    eventMsg: "n/a",
    eventName,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName,
    internalLinkPosition: internalLinkpositionName,
    internalLinkType: `${experienceName}:navigation`,
    internalLinkURL,
    internalLinkZoneName: `${experienceName}:social share`,
  }

  if (returnString) {
    return JSON.stringify(eventInfo)
  }

  return eventInfo
}

export const siteWideWarningModalCloseAnalytics = eventInfo => {
  pushAnalyticsObjToDataLayer(eventInfo)
}
